export const SET_DATA_POSITION = 'SET_DATA_POSITION';

export const SET_MODAL_POSITION = 'SET_MODAL_POSITION';
